/**
 * Date in yyyymmdd format
 */
if ( typeof (  Date.prototype.yyyymmdd ) === 'undefined' ) {
	
	Date.prototype.yyyymmdd = function() {
		var yyyy = this.getFullYear();
		var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
		var dd  = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
		return "".concat(yyyy).concat(mm).concat(dd);
	};
	
}

/**
 * Get uniques from an Array 
 */
if ( typeof ([].getUnique) === 'undefined' ) {
	Array.prototype.getUnique = function(){
	   var u = {}, a = [];
	   for(var i = 0, l = this.length; i < l; ++i){
		  if(u.hasOwnProperty(this[i])) {
			 continue;
		  }
		  a.push(this[i]);
		  u[this[i]] = 1;
	   }
	   return a;
	};
}



/* jshint browser:true */
/* global jQuery */

var hyperSegments = Object.create(null);

hyperSegments.version = '0.0.4';

/**
 * Encodes a string
 * @param   {string} n Decoded string
 * @returns {string} Encoded string
 */
hyperSegments.encode = function(n) {
    var x = 4321 + Number(n);
    return atob(x.toString());
};

/**
 * Decodes a string
 * @param   {string} n Encoded string
 * @returns {string} Decoded string
 */
hyperSegments.decode = function(n) {
    var x = btoa(n);
    x = Number(x - 4321);
    return x.toString();
};

/**
 * Add label to the user. It includes the day of the last visit and an array with days for each visit.
 * @param {string} label (Google Adwords Label)
 */
hyperSegments.addLabel = function(label){
    var today = new Date();
    var labelData = {};
    var labelDataString = "";
    if (localStorage.getItem(label) !== null){
        labelData = JSON.parse( localStorage.getItem(label) );
    }
    labelData.l = this.encode(today.yyyymmdd());
    if ( typeof (labelData.a) == "undefined") {
        labelData.a = [labelData.l];
    } else {
        if ( labelData.a.indexOf(labelData.l) < 0 ) {
            labelData.a.push(labelData.l);
        }
    }
    labelDataString = JSON.stringify(labelData);
    localStorage.setItem(label, labelDataString);
};

/**
 * Loops trough an array of labels and calls the function addLabel on each.
 * @param {Array} labels Array of labels (strings). Normally Google Adwords labels.
 */
hyperSegments.addLabels = function(labels) {
    var self = this;
    if ( cookieTrackingManager.canItrack("segmentation") ) {
        labels.forEach(function(value, index){
            self.addLabel(value);
        });
    }
};

/**
 * Get all labels IDs
 * @returns {Array} A list of all labels Ids (Google Adwords Label)
 */
hyperSegments.getLabelsIds = function() {
    var allKeys = Object.keys(localStorage);
    var labelsIds = [];
    for ( var i=0; i< allKeys.length; i++) {
        if ( /^.{18,20}$/.test( allKeys[i] ) && allKeys[i].substr(0,3) != "_ym"  ) {
            labelsIds.push(allKeys[i]);
        }
    }
    return labelsIds;
};

/**
 * Get a list of labels that have visits less than X days
 * @param   {number} days Days (1 for today, 2 for today and yesterday)
 * @returns {Array} Labels that have a visit within the days range.
 */
hyperSegments.getListOfLabelsIdsSince = function(days) {
    var allLabelssIds = this.getLabelsIds();
    var today = Number(new Date().yyyymmdd());
    var limit = today - days;
    var result = [];
    var lastDayOf;
    var self = this;
    allLabelssIds.forEach(function(value, index) {
        lastDayOf = self.getLastDay(value);
        if (Number(lastDayOf) > limit) {
            result.push(value);
        }
    });
    return result;
};

/**
 * Gets the last label, or one of the last labels from a list of labels.
 * @param   {Array} labels Array of labels
 * @returns {string} Returns one of the last labels (if there's more than one)
 */
hyperSegments.getLastLabel = function(labels){
    var lastLabelId = "";
    var lastLabelDate = "";
    var labelDate = "";
    var self = this;
    labels.forEach(function(value,index){
        if (self.hasLabel(value)) {
            labelDate = self.getLastDay(value);
            if (labelDate > lastLabelDate) {
                lastLabelId = value;
                lastLabelDate = labelDate;
            }
        }
    });
    return lastLabelId;
};

/**
 * Gets the label with most days, or one of the labels with most days, if there are many.
 * @param   {Array} labels Labels that you want to check
 * @returns {string} One of the labels with most days
 */
hyperSegments.getLabelWithMostDays = function(labels) {
    var mostDays = 0;
    var labelNumDays;
    var mostDaysLabel = "";
    var self = this;
    labels.forEach(function(value, index){
        labelNumDays = self.getAllDays(value).length;
        if ( labelNumDays > mostDays ) {
            mostDaysLabel = value;
            mostDays = labelNumDays;
        }
    });
    return mostDaysLabel;
};

/**
 * Remove the label from the user.
 * @param {string} label (Google Adwords Label)
 */
hyperSegments.removeLabel = function(label){
    localStorage.removeItem(label);
};

/**
 * Remove all labels (Keys with names between 18 and 20 chars, like Adwords labels)
 */
hyperSegments.removeAllLabels = function(){
    var labelsToRemove = this.getLabelsIds();
    for ( var i=0; i< labelsToRemove.length; i++) {
        this.removeLabel(labelsToRemove[i]);
    }
};

/**
 * Checks if a label exists
 * @param   {string} label Label, like Google Adwords label
 * @returns {boolean} Result
 */
hyperSegments.hasLabel = function(label) {
    var allLabels = this.getLabelsIds();
    return allLabels.indexOf(label) >= 0;
};

/**
 * Checks if an array of labels exist for the user
 * @param   {Array} labels Array of labels to check
 * @returns {boolean} Result
 */
hyperSegments.hasAnyLabel = function(labels) {
    var hasOneLabel = false;
    var allLabels = this.getLabelsIds();
    for (var i=0; i < labels.length ; i++) {
        if ( allLabels.indexOf(labels[i]) >= 0 ) {
            hasOneLabel = true;
        }
    }
    return hasOneLabel;
};

/**
 * Returns true if the user has all labels
 * @param   {Array} labels Array of labels
 * @returns {boolean} Result
 */
hyperSegments.hasAllLabels = function(labels) {
    var hasAll = true;
    var allLabels = this.getLabelsIds();
    for (var i=0; i < labels.length ; i++) {
        if ( allLabels.indexOf(labels[i]) < 0 ) {
            hasAll = false;
        }
    }
    return hasAll;
};

/**
 * Get the ast day a label was added
 * @param   {string} label Audience label (Google Adwords Label)
 * @returns {string} Last date the label was given YYYYMMDD
 */
hyperSegments.getLastDay = function(label) {
    var labelContent = localStorage.getItem(label);
    var labelContentObject = JSON.parse(labelContent);
    var encondedLastDay = labelContentObject.l;
    return this.decode(encondedLastDay);
};

/**
 * Gets all days from a specific label
 * @param   {string} label Like Google Adwords label
 * @returns {Array} List of all days as YYYYMMDD
 */
hyperSegments.getAllDays = function(label) {
    var self = this;
    var labelObject, allDaysEncoded;
    var allDaysDecoded = [];
    var item = localStorage.getItem(label);
    if (item !==null){
        labelObject = JSON.parse(item);
        allDaysEncoded = labelObject.a;
        allDaysEncoded.forEach(function(value, index){
            allDaysDecoded.push(self.decode(value));
        });
    }
    return allDaysDecoded;
};

/**
 * How many days has the user visited the website
 * @returns {number} Number of days
 */
hyperSegments.getDaysWithSession = function() {
    var daysWithSession;
    if (localStorage.getItem('days_with_session') !== null) {
        daysWithSession = Number(localStorage.getItem('days_with_session')) ;
    } else {
        daysWithSession = 0;
    }
    return daysWithSession;
};

/**
 * Checks if the user's days with session are between the min and the max
 * @param   {number} min Minimum number of days with session (included)
 * @param   {number} max Maximum number of days with session (not included)
 * @returns {boolean} Result
 */
hyperSegments.areDaysWithSessionBetween = function(min, max) {
    if ( max <= min) {
        throw("Max is equal or less than min");
    }
    return (this.getDaysWithSession() >= min && this.getDaysWithSession() < max );
};

/**
 * Cleans lead, donor and ex-donor email sources. If one exists keep the last.
 */
hyperSegments.cleanEmailSources = function(){
    var lastLabel = this.getLastLabel(["TeGeCOHatmoQu4mc9gM","bhNJCLOKnmoQu4mc9gM","tXajCKTfkoEBELuJnPYD"]);
    if ( lastLabel === "bhNJCLOKnmoQu4mc9gM") { // Socios/as
        this.removeLabel("TeGeCOHatmoQu4mc9gM");
        this.removeLabel("tXajCKTfkoEBELuJnPYD");
    } else if ( lastLabel === "TeGeCOHatmoQu4mc9gM") { // lead
        this.removeLabel("bhNJCLOKnmoQu4mc9gM");
        this.removeLabel("tXajCKTfkoEBELuJnPYD");
    } else if ( lastLabel === "tXajCKTfkoEBELuJnPYD") { // ex-socios
        this.removeLabel("bhNJCLOKnmoQu4mc9gM");
        this.removeLabel("TeGeCOHatmoQu4mc9gM");
    }

};

/* jshint browser:true */
/* global jQuery, hyperSegments, OneSignal, gtag, cookieTrackingManager */

cookieTrackingManager.read();

var hyperRemarketing = Object.create(null);

hyperRemarketing.GoogleConversionId = 0; // Configurable remarketing ID (number)

hyperRemarketing.GoogleOtherContentLabel = ''; // Configurable remarketing default content label (string)

hyperRemarketing.GoogleOtherActionLabel = ''; // Default user action, if it's not defined in configUserActionLabels

hyperRemarketing.version = '2.0.0';

/**
 * Configure the content related labels
 */
hyperRemarketing.configContentTagsLabels = [{
    label: '',
    pageTags: [''],
    description: ''
}, {
    label: '',
    pageTags: ['', '', ''],
    description: ''
}];

/**
 * Configure content related labels, with pathnames
 */
hyperRemarketing.configUrlLabels = [{
    label: '',
    urlFragments: ['']
},{
    label: '',
    urlFragments: ['']
}];

/**
 * Configure the traffic source related labels
 */
hyperRemarketing.configTrafficSourceLabels = [{
    label: '',
    utm_source: ['newsletter-leads'],
    utm_medium: ['email']
}, {
    label: '',
    membertype: 'donor',
    utm_source: ['newsletter-socios'],
    utm_medium: ['email']
}];


/**
 * Configure user action related labels
 */
hyperRemarketing.configUserActionLabels = [{
    label: '',
    action: ['signup']
}];


/**
 * Prevent errors
 */
if (typeof window.google_tag_params === 'undefined') {
    window.google_tag_params = {};
}


/**
 * Count days with session and record last visit
 */
hyperRemarketing.addToDaysWithSession = function() {
    var date = new Date();
    if (cookieTrackingManager.canItrack("segmentation") ) {
        if (localStorage.getItem('last_visit') !== null && localStorage.getItem('days_with_session') !== null) {
            if (localStorage.getItem('last_visit') != date.yyyymmdd()) {
                var days_with_session = Number(localStorage.getItem('days_with_session'));
                days_with_session++;
                localStorage.setItem('days_with_session', days_with_session.toString());
            }
        } else {
            localStorage.setItem('days_with_session', '1');
        }
        localStorage.setItem('last_visit', date.yyyymmdd());
    }
};


/**
 * Add days with session and last visit to Google Adwords Params
 */
hyperRemarketing.tagDaysWithSession = function() {
    if (localStorage.getItem('days_with_session') !== null && localStorage.getItem('last_visit') !== null) {
        window.google_tag_params.dayswithsession = Number(localStorage.getItem('days_with_session'));
        window.google_tag_params.lastvisit = Number(localStorage.getItem('last_visit'));
    }
};


/**
 * Saves window.location.search in Session Storage to future use
 * @returns {boolean} True if it saved, false if it didn't
 */
hyperRemarketing.saveLastSourceStringSession = function() {
    if (window.location.search !== '' && cookieTrackingManager.canItrack("segmentation") ) {
        sessionStorage.setItem('last_source_string', window.location.search);
        return true;
    } else {
        return false;
    }
};


/**
 * Gets the last source string either from the URL or session storage
 * @returns {string} Last source string
 */
hyperRemarketing.getLastSourceString = function() {
    if (window.location.search !== '' && cookieTrackingManager.canItrack("segmentation")) {
        return window.location.search;
    } else if (sessionStorage.getItem('last_source_string') !== null) {
        return sessionStorage.getItem('last_source_string');
    } else {
        return '';
    }
};


/**
 * Parse last_source_string. If it includes Google's Adwords gclid : utm_medium = cpc and utm_source = google
 * @param   {string} last_source_string String to parse, starting with ?
 * @returns {object} Parameters and values
 */
hyperRemarketing.getJsonFromString = function(last_source_string) {
    var search = last_source_string.substring(1);
    var result = search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
        function(key, value) {
            return key === "" ? value : decodeURIComponent(value);
        }) : {};
    if (result.gclid) {
        result.utm_medium = "cpc";
        result.utm_source = "google";
    }
    return result;
};


/**
 * If a list of tags was declared as the array window.google_tag_params.pageTags returns window.google_tag_params.pageTags else searches in the DOM and adds them to window.google_tag_params.pageTags.
 * 
 * @returns {Array} List ot tags
 */
hyperRemarketing.getContentTags = function() {

    if (jQuery.isArray(window.google_tag_params.pageTags) && window.google_tag_params.pageTags.length >= 1) {
        return window.google_tag_params.pageTags;
    } else if (jQuery('.sidebar-tags a, .sidebar-categories a').length > 0) {
        window.google_tag_params.pageTags = [];
        jQuery('.sidebar-tags a, .sidebar-categories a').each(function(index, value) {
            var tagText = jQuery(value).find('span').text().toLowerCase();
            window.google_tag_params.pageTags.push(tagText);
        });
        return window.google_tag_params.pageTags;
    } else {
        window.google_tag_params.pageTags = [];
        return window.google_tag_params.pageTags;
    }
};

/**
 * Gets the labels for this call. Should be called either by this or SpanishRemarketing
 * @param   {Array} contentTags Content tags in the page this.getContentTags()
 * @returns {Array} Content labels in the page
 */
hyperRemarketing.getLabelDescriptions = function (contentTags) {
    var contentLabelsDescriptions =[];
    var labelTags, labelDescription;
    for (var i in this.configContentTagsLabels){ 
        if (this.configContentTagsLabels.hasOwnProperty(i)) {
            // ACTING ON THE LABELS LOOP
            labelTags = this.configContentTagsLabels[i].pageTags;
            labelDescription = this.configContentTagsLabels[i].description;
            labelTags.forEach(function(value,index){
                if ( contentTags.indexOf(value) >=0 ) {
                    contentLabelsDescriptions.push(labelDescription);
                }
            });
            // / ACTING ON THE LABELS LOOP
        }
    }
    return contentLabelsDescriptions;
};


/**
 * Searches the label for a specific utm_source and utm_medium
 * Populates window.google_tag_params.membertype with configTrafficSourceLabels membertype
 * @param   {string} utm_source UTM source as defined by the URL Builder
 * @param   {string} utm_medium UTM medium as defined by the URL builder
 * @returns {string} Returns the label correspondant to the source
 */
hyperRemarketing.getSourceTag = function(utm_source, utm_medium) {
    var sourceTag = false;
    var membertype = '';
    jQuery.each(this.configTrafficSourceLabels, function(index, value) {
        if (value.utm_source.indexOf(utm_source) >= 0 && value.utm_medium.indexOf(utm_medium) >= 0) {
            if (typeof value.label === 'string') {
                sourceTag = value.label;
            }
            if (typeof value.membertype === 'string') {
                membertype = value.membertype;
            }
        }
    });
    if (membertype !== '') {
        window.google_tag_params.membertype = membertype;
    }
    return sourceTag;
};

/**
 * Searches the label for aspecific action
 * Populates window.google_tag_params.useraction with the action name
 * @param   {string} action Action name (For example 'signup')
 * @returns {string} Returns the label correspondant to the action, returns the default action label if the action has no labels
 */
hyperRemarketing.getUserActionTag = function(action) {
    var actionTag = this.GoogleOtherActionLabel;
    jQuery.each(this.configUserActionLabels, function(index, value) {
        if (value.action.indexOf(action) >= 0) {
            if (typeof value.label === 'string') {
                actionTag = value.label;
            }
        }
    });

    window.google_tag_params.useraction = action;
    var actionTagArray = [actionTag];
    return actionTagArray;
};


/**
 * Searches the google remarketing label to a specific content tag 
 * @param   {string} contentTag Content tag
 * @returns {string} Returns Google remarketing label
 */
hyperRemarketing.getLabelFromTag = function(contentTag) {
    var returnLabel = false;
    jQuery.each(this.configContentTagsLabels, function(index, value) {
        jQuery.each(value.pageTags, function(indextag, valuetag) {
            if (valuetag === contentTag) {
                returnLabel = value.label;
            }
        });
    });
    return returnLabel;
};

/**
 * Searches the google remarketing label to a specific content url
 * @returns {string} Returns Google remarketing label
 */
hyperRemarketing.getLabelFromUrl = function() {
    var urlFragment = window.location.pathname;
    var returnLabel = false;
    jQuery.each(this.configUrlLabels, function(index,value){
        jQuery.each(value.urlFragments, function(indexfragment, valuefragment){
            if ( urlFragment.indexOf(valuefragment) >= 0 ) {
                returnLabel = value.label;
            }
        });
    });
    return returnLabel;
};

/**
 * Send remarketing info to Google.
 * @param {array} remarketingLabels Array of remarketing labels
 */
hyperRemarketing.sendToGoogle = function(remarketingLabels) {
    var self = this;
    if (cookieTrackingManager.canItrack("advertisement") ) {
        gtag('consent', 'update', {'ad_storage': 'granted'});
    }
    remarketingLabels.forEach(function(value,index){
        gtag('event', 'conversion', {
            'send_to': 'AW-' + self.GoogleConversionId + '/' + value
        });
    });
     
};

/**
 * Add tags array to One Signal
 * @param {Array} remarketingLabels Array of remarketing labels
 */
hyperRemarketing.sendTagsToOneSignal = function(remarketingLabels) {
    if (typeof(OneSignal) === "function" && cookieTrackingManager.canItrack("segmentation")) {
        OneSignal.push(function() {
            var tags = {};
            remarketingLabels.forEach(function(value,index){
                tags[value] = "1";
            });
            OneSignal.sendTags(
                tags,
                function(tagsSent) {
                }
            );
            
        });
    }
};


/**
 *
 * ****** Main tracking method. Starts hypermarketing ******
 * 
 */
hyperRemarketing.track = function() {

    // DAYS WITH SESSION
    this.addToDaysWithSession(); // Count days with session and record last visit
    this.tagDaysWithSession(); // Add days with session and last visit to Google Adwords Params

    // SOURCE, DONNOR, LEAD
    this.saveLastSourceStringSession(); // Saves window.location.search in Session Storage to future use
    var last_source_string = this.getLastSourceString(); // Gets the last source string either from the URL or session storage
    var trafficSource = this.getJsonFromString(last_source_string); // Parse last_source_string
    var sourceLabel = this.getSourceTag(trafficSource.utm_source, trafficSource.utm_medium); // Searches the label for a specific utm_source and utm_medium
    
    // CONTENT TAGS AND LABELS
    var pageTags = this.getContentTags(); // Array with a list of content tags
    var listOfContentLabels = [];
    if (jQuery.isArray(pageTags) && pageTags.length >= 1) {
        var lft;
        var self = this;
        pageTags.forEach(function(value,index){
            lft = self.getLabelFromTag(value); // Searches the google remarketing label to a specific content tag 
            if (lft !== false) {
                listOfContentLabels.push(lft);
            }
        });
    }
    var uniqueContentLabels = listOfContentLabels.getUnique();

    // URL FRAGMENTS AND LABEL
    var urlLabel = this.getLabelFromUrl(); // Searches the google remarketing label to a specific content url
    
    // PUT ALL LABELS IN AN ARRAY AND SEND IT TO GOOGLE
    var allLabels = [];
    if (sourceLabel !== false) {
        allLabels.push(sourceLabel);
    }
    if (urlLabel !== false) {
        allLabels.push(urlLabel);
    }
    if (uniqueContentLabels.length === 2 || uniqueContentLabels.length === 1) { // If there's one or two content labels
        allLabels = allLabels.concat(uniqueContentLabels);
    } else { // Zero or more than 2 content labels
        allLabels = allLabels.concat(this.GoogleOtherContentLabel);
    }
    
    hyperSegments.addLabels(allLabels);
    this.sendToGoogle(allLabels);
    var self2 = this;
    window.addEventListener("load", function(){
        self2.sendTagsToOneSignal(allLabels);
    });
    
};


/**
 * Tracks a user action like signup
 * @param {string} action User action, as defined in configUserActionLabels
 */
hyperRemarketing.trackUserAction = function(action) {
    var userActionLabel = this.getUserActionTag(action);
    hyperSegments.addLabels(userActionLabel);
    this.sendToGoogle(userActionLabel);
};

/* global hyperRemarketing */

var spanishRemarketing = Object.create(hyperRemarketing);

spanishRemarketing.GoogleConversionId = 1053230267; // Remarketing ID cuenta webmaster

spanishRemarketing.GoogleOtherContentLabel = 'fIj0CJ7ZpWoQu4mc9gM'; // Vista otra pagina (HR)

spanishRemarketing.GoogleOtherActionLabel = 'LuFFCP_-pWoQu4mc9gM'; // Otras acciones de usuario (HR)

spanishRemarketing.version = '20180801.1';

/**
 * Configure the content related labels (HR)
 */
spanishRemarketing.configContentTagsLabels = [{
    label: 'vUwHCIqOnmoQu4mc9gM',
    pageTags: ['herencias'],
    description: 'Visita página sobre herencias'// FIXME (no hay tag oficial de herencias)
}, {
    label: 'OhZECJrntmoQu4mc9gM',
    pageTags: ['voluntarios', 'voluntariado', 'movilización'],
    description: 'Visita página de voluntariado'// FIXME (No nay tag oficial de voluntariado)
}, {
    label: 'NIbTCJLNsmoQu4mc9gM',
    pageTags: ['ártico', 'deshielo ártico' ],
    description: 'Visita página sobre Ártico'
}, {
    label: 'rpEsCJ6m534Qu4mc9gM',
    pageTags: ['antártida', 'pingüinos', 'kril'],
    description: 'Visita página sobre Antartida'
}, {
    label: 'cdl4CKTNsmoQu4mc9gM',
    pageTags: ['abejas'],
    description: 'Visita página sobre abejas'
}, {
    label: 'PXyiCI-QnmoQu4mc9gM',
    pageTags: ['plásticos'],
    description: 'Visita página sobre plásticos'
}, {
    label: 'A-_TCKqQnmoQu4mc9gM',
    pageTags: ['pesca', 'pesca de arrastre', 'pesca sostenible'],
    description: 'Visita página sobre pescado'
}, {
    label: '8YVQCM6TnmoQu4mc9gM',
    pageTags: ['agricultura ecológica', 'agricultura industrial', 'monsanto', 'plaguicida', 'glifosato', 'transgénicos', 'alimentación ecológica'],
    description: 'Visita página sobre agricultura / transgénicos'
}, {
    label: 'FwijCNaVnmoQu4mc9gM',
    pageTags: ['greenpeace'],
    description: 'Visita página sobre ONG Greenpeace'
}, {
    label: 'wkZ5CNPQ5GoQu4mc9gM',
    pageTags: ['ttip'],
    description: 'Visita pagina sobre TTIP'
}, {
    label: 'DW-DCO2XnmoQu4mc9gM',
    pageTags: ['cambio climático', 'petróleo', 'desastres naturales', 'eléctricas', 'carbón', 'energía térmica', 'energías renovables', 'renovables', 'energía eólica', 'energía solar', 'energía nuclear', 'residuos nucleares', 'fukushima', 'pobreza energética','nuclear'],
    description: 'Visita página sobre cambio climático'
}, {
    label: 'n88_CJ_vtmoQu4mc9gM',
    pageTags: ['deforestación', 'amazonas', 'indonesia', 'aceite de palma', 'bosque boreal', 'incendios', 'congo', 'doñana', 'madera', 'soja'],
    description: 'Visita página sobre bosques'
}, {
    label: 'gFEtCJqhl3EQu4mc9gM',
    pageTags: ['trump', 'donald trump'],
    description: 'Visita pagina sobre Trump'
}, {
    label: 'HEx4CMHOuIABELuJnPYD',
    pageTags: ['consumismo', 'tecnología'],
    description: 'Visita página sobre consumo'
}, {
    label: 'CUotCOmapoABELuJnPYD',
    pageTags: ['carne', 'ganadería industrial'],
    description: 'Visita página sobre carne'
}, {
    label: 'm5xDCKqRvYABELuJnPYD',
    pageTags: ['desarme', 'desarme nuclear', 'armas'],
    description: 'Visita página sobre desarme'
}, {
    label: 'Os9pCO-apoABELuJnPYD',
    pageTags: ['ballenas', 'orangutanes', 'pingüinos'],
    description: 'Visita página sobre animales'
}, {
    label: 'Os9pCO-apoABELuJnPYD',
    pageTags: ['justicia social', 'libertad de expresión', 'protesta', 'corporaciones'],
    description: 'Visita páginas sobre protesta y libertad de expresión'
},{
    label: 'WAmICMun-9cBELuJnPYD',
    pageTags: [ 'contaminación', 'movilidad sostenible', 'bicicleta', 'coches', 'transporte público', 'diesel', 'transporte' ],
    description: 'Visita páginas sobre movilidad'
},{
    label: 'wtqACN_xidgBELuJnPYD',
    pageTags: ['agua', 'sequía', 'desertificación'],
    description: 'Visita páginas sobre agua'
},{
    label: 'zQWMCJL7idgBELuJnPYD',
    pageTags: [ 'Tratado Océanos', 'santuarios marinos'],
    description: 'Visita páginas sobre océanos'
},{
    label: 'PYQMCMeAitgBELuJnPYD',
    pageTags: ['ecofeminismo', 'género'],
    description: 'Visita sobre páginas de ecofeminismo (HR)'
}
];

/**
 * Configure content related labels, with pathnames
 */
spanishRemarketing.configUrlLabels = [{
    label: 'vUwHCIqOnmoQu4mc9gM', // Visita pagina de herencias (HR)
    urlFragments: ['/es/que-puedes-hacer-tu/testamento-solidario/']
},{
    label: 'NIbTCJLNsmoQu4mc9gM', // Visita página sobre Ártico (HR)
    urlFragments: ['/es/trabajamos-en/oceanos/artico/']
},{
    label: 'rpEsCJ6m534Qu4mc9gM', // Visita página sobre Antartida (HR)
    urlFragments: ['/es/trabajamos-en/oceanos/antartida/']
},{
    label: '8YVQCM6TnmoQu4mc9gM', // Visita página sobre agricultura / transgénicos (HR)
    urlFragments: ['/es/trabajamos-en/agricultura/'] 
},  {
    label: 'cdl4CKTNsmoQu4mc9gM', // Visita página sobre abejas (HR)
    urlFragments: ['/es/trabajamos-en/agricultura/abejas/']    
},{
    label: 'PXyiCI-QnmoQu4mc9gM', // Visita página sobre plásticos (HR)
    urlFragments: ['/es/trabajamos-en/consumismo/plasticos/']    
},{
    label: 'A-_TCKqQnmoQu4mc9gM', // Visita página sobre pescado (HR)
    urlFragments: ['/es/trabajamos-en/oceanos/pesca/'] 
},{
    label: 'FwijCNaVnmoQu4mc9gM', // Visita página sobre ONG Greenpeace (HR)
    urlFragments: ['/es/quienes-somos/'] 
},{
    label: 'DW-DCO2XnmoQu4mc9gM', // Visita página sobre cambio climático (HR)
    urlFragments: ['/es/trabajamos-en/cambio-climatico/'] 
},{
    label: 'n88_CJ_vtmoQu4mc9gM', // Visita página sobre bosques (HR)
    urlFragments: ['/es/trabajamos-en/bosques/'] 
},{
    label: 'HEx4CMHOuIABELuJnPYD', // Visita páginas con consumo (HR)
    urlFragments: ['/es/que-puedes-hacer-tu/consumo/', '/es/trabajamos-en/consumismo/']
},{
    label: 'CUotCOmapoABELuJnPYD', // Visita páginas de carne (HR)
    urlFragments: ['/es/trabajamos-en/consumismo/carne/']
},{
    label: 'm5xDCKqRvYABELuJnPYD', // Visita páginas de desarme (HR)
    urlFragments: ['/es/trabajamos-en/desarme/']
},{
    label: 'Os9pCO-apoABELuJnPYD', // Visita páginas de animales (HR)
    urlFragments: ['/es/trabajamos-en/oceanos/ballenas/']
}];

/**
 * Configure the traffic source related labels
 */
spanishRemarketing.configTrafficSourceLabels = [{
    label: 'TeGeCOHatmoQu4mc9gM', // Click en newsletter a leads (HR)
    membertype: 'lead',
    utm_source: ['newsletter-leads'],
    utm_medium: ['email']
},{
    label: 'bhNJCLOKnmoQu4mc9gM', // Click en newsletter a socios (HR)
    membertype: 'donor',
    utm_source: ['newsletter-socios'],
    utm_medium: ['email']

},{
    label: 'tXajCKTfkoEBELuJnPYD', // Click en newsletter a ex-socios (HR)
    membertype: 'exdonor',
    utm_source: ['newsletter-ex'],
    utm_medium: ['email']
},{
    label: 'HaBMCK2RvYABELuJnPYD', // Click cpc y post-promocionado (HR)
    membertype: '',
    utm_source: ['google'],
    utm_medium: ['cpc']
},{
    label: 'HaBMCK2RvYABELuJnPYD', // Click cpc y post-promocionado (HR)
    membertype: '',
    utm_source: ['twitter'],
    utm_medium: ['cpc']
},{
    label: 'HaBMCK2RvYABELuJnPYD', // Click cpc y post-promocionado (HR)
    membertype: '',
    utm_source: ['outbrain'],
    utm_medium: ['cpc']
},{
    label: 'HaBMCK2RvYABELuJnPYD', // Click cpc y post-promocionado (HR)
    membertype: '',
    utm_source: ['facebook'],
    utm_medium: ['post-promocionado']
},{
    label: 'HaBMCK2RvYABELuJnPYD', // Click cpc y post-promocionado (HR)
    membertype: '',
    utm_source: ['instagram'],
    utm_medium: ['post-promocionado']
}];


/**
 * Configure user action related labels
 */
spanishRemarketing.configUserActionLabels = [{
    label: 'Pqa7CIX_pWoQu4mc9gM', // Firma de petición general (HR)
    action: ['signup']
}, {
    label: 'Pqa7CIX_pWoQu4mc9gM', // Firma de petición general (HR)
    action: ['signup-artico']
}, {
    label: 'Pqa7CIX_pWoQu4mc9gM', // Firma de petición general (HR)
    action: ['signup-abejas']
}, {
    label: 'Gzn6CJrktmoQu4mc9gM', // Se hace socio online (HR)
    action: ['regular-donation']
}, {
    label: 'GWb8CNHltmoQu4mc9gM', // Hace una donación online (HR)
    action: ['one-donation']
}, {
    label: '1EMJCN7q0oYBELuJnPYD', // Comenta en el blog (HR)
    action: ['comment']
}];

/* jshint browser:true */
/* global jQuery, console, hyperSegments */

var hyperDom = Object.create(null);

hyperDom.version = '0.0.1';

/**
 * Allways return a trimmed array of labels
 * @param labelString A comma separated string or array of labels
 * @returns {Array} The list of labels
 */
hyperDom.getDataLabels = function(labelString) {
    var arrayOfLabels;
    var cleanArrayOfLabels = [];
    if (typeof(labelString) === "string") {
        arrayOfLabels = labelString.split(",");
        for (var n=0; n < arrayOfLabels.length ; n++) {
            cleanArrayOfLabels.push(arrayOfLabels[n].trim());
        }
        arrayOfLabels = cleanArrayOfLabels;
    } else if ( jQuery.isArray(labelString) ) {
        arrayOfLabels = labelString;
    } else {
        arrayOfLabels = [];
    }
    return arrayOfLabels;
};

/**
 * Processing data-show-if-any data attribute
 */
hyperDom.dataShowIfAny = function() {
    var showThisNode = false;
    var labelsArray;
    var labels; // var labels, secondParam;
    jQuery("*[data-show-if-any]").each(function(index, value){
        // console.log(jQuery(this).text());

        labels = jQuery(this).data("showIfAny");
        labelsArray = hyperDom.getDataLabels(labels);
        // console.log (labelsArray);

        showThisNode = hyperSegments.hasAnyLabel(labelsArray);
        // showThisNode = true;

//        secondParam = jQuery(this).data("secondParam");
//        if (typeof(secondParam) != "undefined") {
//            console.log( secondParam );
//            showThisNode = true;
//        }

        if (showThisNode === true) {
            jQuery(this).addClass("hyperShow");
        }

    });
};

hyperDom.dataShowIfAny();


/**
 * Processing data-show-if-all data attribute
 */
hyperDom.dataShowIfAll = function() {
    var showThisNode = false;
    var labelsArray;
    var labels;
    jQuery("*[data-show-if-all]").each(function(index, value){
        labels = jQuery(this).data("showIfAll");
        labelsArray = hyperDom.getDataLabels(labels);
        showThisNode = hyperSegments.hasAllLabels(labelsArray);
        if (showThisNode === true) {
            jQuery(this).addClass("hyperShow");
        }
    });
};
hyperDom.dataShowIfAll();

/**
 * Processing data-hide-if-any data attribute
 */
hyperDom.dataHideIfAny = function() {
    var showThisNode = false;
    var labelsArray;
    var labels;
    jQuery("*[data-hide-if-any]").each(function(index, value){
        labels = jQuery(this).data("hideIfAny");
        labelsArray = hyperDom.getDataLabels(labels);
        showThisNode = hyperSegments.hasAnyLabel(labelsArray);
        showThisNode = !showThisNode;
        if (showThisNode === true) {
            jQuery(this).addClass("hyperShow");
        }
    });
};
hyperDom.dataHideIfAny();


/**
 * Processing data-hide-if-all data attribute
 */
hyperDom.dataHideIfAll = function() {
    var showThisNode = false;
    var labelsArray;
    var labels;
    jQuery("*[data-hide-if-all]").each(function(index, value){
        labels = jQuery(this).data("hideIfAll");
        labelsArray = hyperDom.getDataLabels(labels);
        showThisNode = hyperSegments.hasAllLabels(labelsArray);
        showThisNode = !showThisNode;
        if (showThisNode === true) {
            jQuery(this).addClass("hyperShow");
        }
    });
};
hyperDom.dataHideIfAll();

/**
 * Processing data-run-function data attribute
 */
hyperDom.runFunction = function(){
    var funcName;
    jQuery("*[data-run-function]").each(function(index,value){
        funcName = jQuery(this).data("runFunction");
        if ( /^([a-zA-Z]|\d)+$/.test(funcName) ) {
            eval( funcName + '(this)');
        } else {
            throw("Wrong data-run-function name in the HTML");
        }
    }
    );
};
hyperDom.runFunction();

/**
 * Processing data-show-if-most-recent-of data attribute and data-is
 */
hyperDom.showIfMostRecentOf = function() {
    var labels;
    var isMostRecent;
    jQuery("*[data-show-if-most-recent-of]").each(function(index, value){
        labels = jQuery(this).data("showIfMostRecentOf");
        labelsArray = hyperDom.getDataLabels(labels);
        isMostRecent = jQuery(this).data("is");
        if ( isMostRecent === hyperSegments.getLastLabel(labelsArray) ) {
            jQuery(this).addClass("hyperShow");
        }
    });
};
hyperDom.showIfMostRecentOf();

/**
 * Processing data-show-if-most-popular-of data attribute and data-is
 */
hyperDom.showIfMostPopularOf = function() {
    var labels;
    var isMostPopular;
    jQuery("*[data-show-if-most-popular-of]").each(function(index, value){
        labels = jQuery(this).data("showIfMostPopularOf");
        labelsArray = hyperDom.getDataLabels(labels);
        isMostPopular = jQuery(this).data("is");
        if ( isMostPopular === hyperSegments.getLabelWithMostDays(labelsArray) ) {
            jQuery(this).addClass("hyperShow");
        }
    });
};
hyperDom.showIfMostPopularOf();